
export default {
    name: 'statistique-diagnostiques',
    components: {},
    props: [],
    data() {
        return {
            l_month: [
                { nth_month: 1, month: "Janvier" }, { nth_month: 2, month: "Février" },
                { nth_month: 3, month: "Mars" }, { nth_month: 4, month: "Avril" },
                { nth_month: 5, month: "Mai" }, { nth_month: 6, month: "Juin" },
                { nth_month: 7, month: "Juillet" }, { nth_month: 8, month: "Août" },
                { nth_month: 9, month: "Septembre" }, { nth_month: 10, month: "Octobre" },
                { nth_month: 11, month: "Novemebre" }, { nth_month: 12, month: "Décembre" }
            ],
            curr_stat_month: '',
            stat_loading: true,
            stat_empty: false,

            stats_date: '',

            fields: [
                'diagnostic', { key: 'femme', label: 'F' },
                { key: 'homme', label: 'H' }, { key: 'enfant', label: 'Enf. < 5' },
                'total'
            ],
            filter: "",
            tableIsBusy: true,
            perPage: 10,
            currentPage: 1,
        }
    },

    watch: {
        curr_stat_month() {
            this.getStatistiqueSante(1)
        }
    },

    computed: {
        statistique_sante() {
            return this.$store.getters['stats_sante'];
        },

        rows() {
            return this.statistique_sante.length;
        },
    },

    mounted() {

        this.curr_stat_month = {
            nth_month: 6,
            month: "Juin"
        }

        // statistique sante
        this.getStatistiqueSante(1)
    },

    methods: {
        getStatistiqueSante(type_filtre) {
            
            this.stat_loading = true
            var s_filter = {}
            
            if (type_filtre == 1) { // FIltre par mois
                s_filter = {
                    type_filtre: 1,
                    date: this.curr_stat_month.nth_month
                }
            } else {
                s_filter = {
                    type_filtre: 2,
                    date: this.stats_date
                }
            }
            console.log(">>> SSS: ",s_filter)
            
            this.$store.dispatch('getStatistiqueSante', s_filter).then(() => {
                if (this.statistique_sante.length > 0) {
                    this.stat_empty = false

                    if (this.statistique_sante.length > 3) {
                        this.stats_more = true
                    }
                } else {
                    this.stat_empty = true
                }

                this.stat_loading = false
            })
        },
    }
}


